import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {BasketPageService_GetRecommendationsLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/page/service.grpc.lazy';
import {GetRecommendationsRequest_BasketItem} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/page/service.types';
import {
  useBasketStateItems,
  useFullSession,
  useWishlistProductIds,
} from '@aboutyou/user';
import {useEffect, useRef} from 'react';
import {useStaleLastSeenProductIds} from '../../../features/LastSeenProducts/useLastSeenProductIds';
import {useReductionsStateRequestParameter} from '../../../features/ReductionsState/useReductionsStateRequestParameter';
import {useTargetGroupIdentifier} from '../../../shared-deprecated/useTargetGroupIdentifier';

const BASKET_RECOMMENDATION_LAST_SEEN_PRODUCT_IDS =
  'BASKET_RECOMMENDATION_LAST_SEEN_PRODUCT_IDS';

export const useRecommendations = (inView: boolean) => {
  const wishlistProductIds = useWishlistProductIds();
  const session = useFullSession();
  const lastSeenProductIds = useStaleLastSeenProductIds({
    uniqueKey: BASKET_RECOMMENDATION_LAST_SEEN_PRODUCT_IDS,
  });
  const basketStateItems = useBasketStateItems();
  const WLProductIds = useRef<number[] | undefined>(wishlistProductIds);
  const targetGroup = useTargetGroupIdentifier();

  useEffect(() => {
    if (!WLProductIds.current?.length) {
      WLProductIds.current = wishlistProductIds;
    }
  }, [wishlistProductIds]);

  const basketItems = basketStateItems.reduce((acc, item) => {
    return [
      ...acc,
      {
        productId: item.productId,
        sizeId: item.sizeId,
      },
    ];
  }, [] as GetRecommendationsRequest_BasketItem[]);

  const isDisabled = () => {
    if (!session || !inView || !basketItems) {
      return true;
    }
    if (!wishlistProductIds.length && !lastSeenProductIds?.length) {
      // Only disable recommendation when both wishlistproducts and last seen products are missing
      return true;
    }
    return false;
  };

  return useGrpcRequest(
    BasketPageService_GetRecommendationsLazy,
    {
      session: session!,
      wishlistProductIds: WLProductIds.current!,
      lastSeenProductIds: lastSeenProductIds || [],
      basketProductIds: [],
      basketItems: basketItems!,
      reductionsState: useReductionsStateRequestParameter(),
      targetGroup,
    },
    {
      keepPreviousData: true,
      disabled: isDisabled(),
    },
  );
};
